import {
  IAppContext as CareerPageSettings,
  saveCareerPageSettings,
  ICareerPageSettingDTO,
  getPresignedURLForPut,
  IFileInfoDTO,
  fileUploadToS3,
  getPresignedURLForGet,
  getCareerPageBySlug,
  getCareerPageByDomain,
} from 'wisestep-api';

import { INotification } from '../../../utils/NotificationStore';

const saveSettings = async (careerPageSettings: CareerPageSettings): Promise<INotification> => {
  const request: ICareerPageSettingDTO = createRequest(careerPageSettings);
  await saveCareerPageSettings(request);
  return {
    message: 'Saved CareerPage Settings',
    type: 'success',
  };
};
export default saveSettings;

const createRequest = (careerPageSettings: CareerPageSettings): ICareerPageSettingDTO => {
  const request: ICareerPageSettingDTO = {
    appearanceSettings: JSON.stringify(careerPageSettings.appearanceSettings),
    generalSettings: JSON.stringify(careerPageSettings.generalSettings),
    candidatesSettings: JSON.stringify(careerPageSettings.candidatesSettings),
    emailSettings: JSON.stringify(careerPageSettings.emailSettings),
    integrationSettings: JSON.stringify(careerPageSettings.integrationSettings),
    domain: careerPageSettings.domain,
    isPreview: careerPageSettings.isPreview,
    jobsSettings: JSON.stringify(careerPageSettings.jobsSettings),
    slug: careerPageSettings.slug,
    userId: careerPageSettings.userId,
  };
  return request;
};

export const uploadFile = async (file: File) => {
  const request: IFileInfoDTO = {
    fileName: file.name,
    fileType: file.type,
  };
  const response = await getPresignedURLForPut(request);
  if (response?.data) {
    const resp = response.data;
    const presignedURl = resp.preSignedUrl;
    const s3Upload = await fileUploadToS3(file, presignedURl);
    console.log(s3Upload);
    return presignedURl;
  }
  return '';
};
export const getFile = async (url: string) => {
  const request: IFileInfoDTO = {
    fileName: url,
    downloadAs: 'image',
  };
  const response = await getPresignedURLForGet(request);
  if (response?.data) {
    return response.data.preSignedUrl;
  }
};

export const checkCompanyBySlug = async (slug: string, existingSlug: string) => {
  if (slug === existingSlug) {
    return false;
  }
  const existingPageResponse = await getCareerPageBySlug(slug);
  const page = existingPageResponse.data;
  if (page.userId) return true;

  return false;
};

export const checkCompanyByDomain = async (domain: string, existingDomain: string) => {
  if (existingDomain === domain) {
    return false;
  }
  const existingPageResponse = await getCareerPageByDomain(domain);
  const page = existingPageResponse.data;
  if (page.userId) return true;

  return false;
};
